import React from 'react';
import * as FjPrimitives from 'components/primitives';

import * as Utils from 'utils';
import { Modal, AlertMessage } from 'components/styled-primitives';

interface ResponseModalProps {
  updatedUsers: unknown[];
  uiArrayFailed: React.ReactNode;
  closeModal: () => void;
  error: React.ReactNode;
}

const ResponseModal = ({
  updatedUsers,
  uiArrayFailed,
  closeModal,
  error,
}: ResponseModalProps): React.ReactElement => {
  const hasError = !!(error && uiArrayFailed);
  return (
    <Modal
      accept={{
        text: 'OK',
        callback: closeModal,
      }}
      title={`Successfully updated ${updatedUsers.length} ${Utils.pluralize(
        updatedUsers.length,
        'user',
      )}.`}
      centerContent={!hasError}
      size={FjPrimitives.fjModalSizes[hasError ? 'SM' : 'XS']}
    >
      {hasError && (
        <React.Fragment>
          <AlertMessage>{error}</AlertMessage>
          <br />
          <AlertMessage noIcon>{uiArrayFailed}</AlertMessage>
        </React.Fragment>
      )}
    </Modal>
  );
};

export default ResponseModal;
